// /* eslint-disable @typescript-eslint/no-unused-vars */
// import { useState } from "react";
// import { IconArchive, IconRefresh, IconPlus } from "@tabler/icons-react";
// import MessageModal from "../../../components/MessageModal";
// import toast from "react-hot-toast";
// import { useUpdateShelveStatusMutation } from "../../../apis/shelveApis";

// interface RackLevelElementProps {
//   rackLevelId: string;
//   rackLevelName: string;
//   rackLevel: any;
//   pallets: Array<any>;
//   bins: Array<any>;
//   fetchShelves: () => void;
//   isParentRowArchived?: boolean;
// }

// const RackLevelElement: React.FC<RackLevelElementProps> = ({
//   rackLevelId,
//   rackLevelName,
//   rackLevel,
//   fetchShelves,
//   isParentRowArchived,
// }) => {
//   const [archiveInstanceOpen, setArchiveInstanceOpen] = useState(false);
//   const [binConfirmModal, setBinConfirmModal] = useState<{
//     open: boolean;
//     bin: any;
//     action: 'archive' | 'restore';
//   }>({ open: false, bin: null, action: 'archive' });
//   const [palletConfirmModal, setPalletConfirmModal] = useState<{
//     open: boolean;
//     pallet: any;
//     action: 'archive' | 'restore';
//   }>({ open: false, pallet: null, action: 'archive' });

//   const isActive = rackLevel?.status !== "INACTIVE";
//   const isDisabled = isParentRowArchived;

//   const { mutate: updatePalletStatus, isPending: isPalletUpdatePending } = useUpdateShelveStatusMutation();

//   const { mutate: toggleLevelStatus, isPending: isLevelUpdatePending } =
//     useUpdateShelveStatusMutation();

//   const handleToggleLevel = () => {
//     toggleLevelStatus(
//       {
//         id: rackLevelId,
//         status: isActive ? "INACTIVE" : "ACTIVE",
//         model: "level",
//       },
//       {
//         onSuccess: () => {
//           toast.success("Status updated successfully");
//           fetchShelves();
//           setArchiveInstanceOpen(false);
//         },
//         onError: (err: any) => {
//           toast.error(err.message);
//         },
//       },
//     );
//   };

//   const renderBins = () => {
//     return rackLevel?.bin?.map((bin: any) => {
//       const isBinActive = bin.status !== "INACTIVE";

//       return (
//         <div key={bin.id} className="relative group/bin">
//           <div
//             className={`p-2 border rounded-lg text-center flex flex-col items-center justify-center transition-all ${
//               isDisabled
//                 ? "bg-gray-100 border-gray-300 text-gray-400 opacity-50 cursor-not-allowed"
//                 : isBinActive
//                   ? "bg-gray-50 border-gray-300 text-gray-700"
//                   : "bg-gray-200 border-gray-400 text-gray-400 opacity-60"
//             }`}
//           >
//             <span className="font-mono text-[10px] font-bold">
//               {bin.name}
//             </span>

//             {!isDisabled && (
//               <button
//                 className={`absolute -top-1 -right-1 p-0.5 rounded-full shadow-sm border bg-white opacity-0 group-hover/bin:opacity-100 transition-opacity ${
//                   isBinActive
//                     ? "text-red-500 hover:bg-red-50"
//                     : "text-blue-500 hover:bg-blue-50"
//                 }`}
//                 title={isBinActive ? "Archive Bin" : "Restore Bin"}
//                 onClick={() => {
//                   setBinConfirmModal({
//                     open: true,
//                     bin: bin,
//                     action: isBinActive ? 'archive' : 'restore'
//                   });
//                 }}
//               >
//                 {isBinActive ? (
//                   <IconArchive size={12} />
//                 ) : (
//                   <IconRefresh size={12} />
//                 )}
//               </button>
//             )}
//           </div>
//         </div>
//       );
//     });
//   };

//   const renderPallets = () => {
//   return rackLevel?.pallet?.map((pallet: any) => {
//     const isActive = pallet.status !== "INACTIVE";

//     return (
//       <div key={pallet.id} className="relative group/pallet">
//         <div
//           className={`p-2 border rounded-lg text-center flex flex-col items-center justify-center ${
//             isDisabled
//               ? "bg-gray-100 border-gray-300 text-gray-400 opacity-50 cursor-not-allowed"
//               : isActive
//                 ? "bg-yellow-50 border-yellow-300 text-yellow-700"
//                 : "bg-gray-200 border-gray-400 text-gray-400 opacity-60"
//           }`}
//         >
//           <span className="font-mono text-[10px] font-bold">
//             {pallet.name}
//           </span>
//         </div>
        
//         {/* Archive/Restore Button for Individual Pallet */}
//         {!isDisabled && (
//           <button
//             className={`absolute -top-1 -right-1 p-0.5 rounded-full shadow-sm border bg-white opacity-0 group-hover/pallet:opacity-100 transition-opacity ${
//               isActive
//                 ? "text-red-500 hover:bg-red-50"
//                 : "text-blue-500 hover:bg-blue-50"
//             }`}
//             title={isActive ? "Archive Pallet" : "Restore Pallet"}
//             onClick={() => {
//               setPalletConfirmModal({
//                 open: true,
//                 pallet: pallet,
//                 action: isActive ? 'archive' : 'restore'
//               });
//             }}
//           >
//             {isActive ? (
//               <IconArchive size={12} />
//             ) : (
//               <IconRefresh size={12} />
//             )}
//           </button>
//         )}
//       </div>
//     );
//   });
// };

//   return (
//     <>
//       <div
//         className={`px-2 transition-all ${!isActive ? "opacity-60 grayscale-[0.5]" : ""}`}
//       >
//         <div
//           className={`border p-3 space-y-3 rounded-xl shadow-sm hover:border-blue-400 transition-colors group ${
//             isActive
//               ? "bg-white border-gray-200"
//               : "bg-gray-100 border-gray-300"
//           }`}
//         >
//           <div className="flex justify-between items-center">
//             <div className="flex items-center gap-2">
//               <h5 className="font-bold text-sm text-gray-800">
//                 {rackLevelName}
//               </h5>
//               <span
//                 className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider ${
//                   isActive
//                     ? "bg-blue-50 text-blue-600"
//                     : "bg-gray-300 text-gray-600"
//                 }`}
//               >
//                 {isActive ? "Active Level" : "Inactive"}
//               </span>
//             </div>

//             <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
//               {!isDisabled && (
//                 <button
//                   onClick={() => setArchiveInstanceOpen(true)}
//                   className={`p-1 rounded ${isActive ? "hover:bg-red-50 text-red-500" : "hover:bg-blue-50 text-blue-600"}`}
//                   title={isActive ? "Archive Level" : "Restore Level"}
//                 >
//                   {isActive ? (
//                     <IconArchive size={18} />
//                   ) : (
//                     <IconRefresh size={18} />
//                   )}
//                 </button>
//               )}
//             </div>
//           </div>

//           {/* Grid for Bins inside the Level */}
//           <div className="grid grid-cols-2 gap-2 pt-1">{renderBins()}</div>
//           {rackLevel?.pallet?.length > 0 && (
//             <div className="grid grid-cols-2 gap-2 pt-2">
//               {renderPallets()}
//             </div>
//           )}
//         </div>
//       </div>
//       <MessageModal
//         open={archiveInstanceOpen}
//         onClose={() => setArchiveInstanceOpen(false)}
//         title={isActive ? "Deactivate Level?" : "Reactivate Level?"}
//         subtitle={
//           isActive
//             ? "This will hide all bins in this level from daily operations."
//             : "This will make all bins in this level available again."
//         }
//         img={isActive ? "/img/archive.png" : "/img/reset.png"}
//         showFooter={true}
//         actionButtonText={isActive ? "Archive Level" : "Restore Level"}
//         actionButtonOnClick={handleToggleLevel}
//         isPending={isLevelUpdatePending}
//       />
//       <MessageModal
//         open={binConfirmModal.open}
//         onClose={() => setBinConfirmModal({ open: false, bin: null, action: 'archive' })}
//         title={binConfirmModal.action === 'archive' ? 'Archive Bin?' : 'Restore Bin?'}
//         subtitle={
//           binConfirmModal.action === 'archive'
//             ? `This will hide bin ${binConfirmModal.bin?.binName || binConfirmModal.bin?.name || 'Unknown'} from daily operations.`
//             : `This will make bin ${binConfirmModal.bin?.binName || binConfirmModal.bin?.name || 'Unknown'} available again.`
//         }
//         img={binConfirmModal.action === 'archive' ? '/img/archive.png' : '/img/reset.png'}
//         showFooter={true}
//         actionButtonText={binConfirmModal.action === 'archive' ? 'Archive Bin' : 'Restore Bin'}
//         actionButtonOnClick={() => {
//           toggleLevelStatus(
//             {
//               id: binConfirmModal.bin.id,
//               status: binConfirmModal.action === 'archive' ? "INACTIVE" : "ACTIVE",
//               model: "bin",
//             },
//             {
//               onSuccess: () => {
//                 toast.success(
//                   binConfirmModal.action === 'archive'
//                     ? `Bin ${binConfirmModal.bin?.binName || binConfirmModal.bin?.name || 'Unknown'} archived`
//                     : `Bin ${binConfirmModal.bin?.binName || binConfirmModal.bin?.name || 'Unknown'} restored`,
//                 );
//                 setBinConfirmModal({ open: false, bin: null, action: 'archive' });
//                 fetchShelves();
//               },
//               onError: (error: any) => {
//                 toast.error(error.message);
//               },
//             },
//           );
//         }}
//         isPending={false}
//       />
//       <MessageModal
//         open={palletConfirmModal.open}
//         onClose={() => setPalletConfirmModal({ open: false, pallet: null, action: 'archive' })}
//         title={palletConfirmModal.action === 'archive' ? 'Archive Pallet?' : 'Restore Pallet?'}
//         subtitle={
//           palletConfirmModal.action === 'archive'
//             ? `This will hide pallet ${palletConfirmModal.pallet?.name || 'Unknown'} from daily operations.`
//             : `This will make pallet ${palletConfirmModal.pallet?.name || 'Unknown'} available again.`
//         }
//         img={palletConfirmModal.action === 'archive' ? '/img/archive.png' : '/img/reset.png'}
//         showFooter={true}
//         actionButtonText={palletConfirmModal.action === 'archive' ? 'Archive Pallet' : 'Restore Pallet'}
//         actionButtonOnClick={() => {
//           updatePalletStatus(
//             {
//               id: palletConfirmModal.pallet.id,
//               status: palletConfirmModal.action === 'archive' ? "INACTIVE" : "ACTIVE",
//               model: "pallet"
//             },
//             {
//               onSuccess: () => {
//                 toast.success(
//                   palletConfirmModal.action === 'archive'
//                     ? `Pallet ${palletConfirmModal.pallet?.name || 'Unknown'} archived`
//                     : `Pallet ${palletConfirmModal.pallet?.name || 'Unknown'} restored`
//                 );
//                 setPalletConfirmModal({ open: false, pallet: null, action: 'archive' });
//                 fetchShelves();
//               },
//               onError: (error: any) => {
//                 toast.error(`Failed to ${palletConfirmModal.action} pallet: ${error.message}`);
//               }
//             }
//           );
//         }}
//         isPending={false}
//       />
//     </>
//   );
// };

// export default RackLevelElement;



/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState, useEffect } from "react";
import { IconArchive, IconRefresh, IconPlus, IconBox, IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
import MessageModal from "../../../components/MessageModal";
import toast from "react-hot-toast";
import { useUpdateShelveStatusMutation } from "../../../apis/shelveApis";

interface RackLevelElementProps {
  rackLevelId: string;
  rackLevelName: string;
  rackLevel: any;
  pallets: Array<any>;
  bins: Array<any>;
  fetchShelves: () => void;
  isParentRowArchived?: boolean;
  onItemClick?: (item: any, type: "bin" | "pallet" | "shipment") => void;
  onClick?: () => void;
  onDoubleClick?: () => void;
  isSelected?: boolean;
}


const RackLevelElement: React.FC<RackLevelElementProps> = ({
  rackLevelId,
  rackLevelName,
  rackLevel,
  fetchShelves,
  isParentRowArchived,
  onItemClick,
  onClick,
  onDoubleClick,
  isSelected,
}) => {
  const [archiveInstanceOpen, setArchiveInstanceOpen] = useState(false);
  const [binConfirmModal, setBinConfirmModal] = useState<{
    open: boolean;
    bin: any;
    action: 'archive' | 'restore';
  }>({ open: false, bin: null, action: 'archive' });
  const [palletConfirmModal, setPalletConfirmModal] = useState<{
    open: boolean;
    pallet: any;
    action: 'archive' | 'restore';
  }>({ open: false, pallet: null, action: 'archive' });

  const isActive = rackLevel?.status !== "INACTIVE";
  const isDisabled = isParentRowArchived;

  const { mutate: updatePalletStatus, isPending: isPalletUpdatePending } = useUpdateShelveStatusMutation();

  const { mutate: toggleLevelStatus, isPending: isLevelUpdatePending } =
    useUpdateShelveStatusMutation();

  const handleToggleLevel = () => {
    toggleLevelStatus(
      {
        id: rackLevelId,
        status: isActive ? "INACTIVE" : "ACTIVE",
        model: "level",
      },
      {
        onSuccess: () => {
          toast.success("Status updated successfully");
          fetchShelves();
          setArchiveInstanceOpen(false);
        },
        onError: (err: any) => {
          toast.error(err.message);
        },
      },
    );
  };

  const [startIndex, setStartIndex] = useState(0);

  useEffect(() => {
    setStartIndex(0);
  }, [rackLevelId, rackLevel?.bin?.length, rackLevel?.pallet?.length]);

  const items: Array<{
    type: "bin" | "pallet" | "shipment";
    data: any;
  }> = [];

  if (rackLevel?.bin && rackLevel.bin.length > 0) {
    rackLevel.bin.forEach((bin: any) => {
      items.push({ type: "bin", data: bin });
    });
  }

  if (rackLevel?.pallet && rackLevel.pallet.length > 0) {
    rackLevel.pallet.forEach((pallet: any) => {
      items.push({ type: "pallet", data: pallet });
    });
  }

  if (rackLevel?.currentInventoryCount > 0) {
    items.push({ type: "shipment", data: rackLevel });
  }

  const renderSingleBin = (bin: any) => {
    const isBinActive = bin.status !== "INACTIVE";
    const isArchived = isDisabled || !isBinActive;
    const isOccupied = isBinActive && (bin.currentInventoryCount || 0) > 0;

    const bgClass = isArchived
      ? "bg-zinc-100/70 border-zinc-200 text-zinc-400 opacity-60 cursor-not-allowed"
      : isOccupied
        ? "bg-green-50 border-green-300 text-green-800 cursor-pointer hover:bg-green-100/60 hover:shadow-md hover:scale-[1.02]"
        : "bg-amber-50 border-amber-300 text-amber-900 cursor-pointer hover:bg-amber-100/60 hover:shadow-md hover:scale-[1.02]";

    const textClass = isArchived
      ? "text-zinc-400 font-bold"
      : isOccupied
        ? "text-green-800 font-bold"
        : "text-amber-900 font-bold";

    const subtextClass = isArchived
      ? "text-zinc-400"
      : isOccupied
        ? "text-green-600 font-semibold"
        : "text-amber-600 font-semibold";

    return (
      <div key={bin.id} className="relative group/bin w-full">
        <div
          onClick={(e) => {
            e.stopPropagation();
            if (!isDisabled) {
              onItemClick?.(bin, "bin");
            }
          }}
          className={`rounded-xl border p-2 text-center transition-all ${bgClass}`}
        >
          <div className={`text-xs ${textClass} truncate`} title={bin.name}>
            {bin.name}
          </div>
          <div className={`text-[9px] mt-0.5 ${subtextClass}`}>
            {isArchived ? "Archived" : "Bin"}
          </div>
        </div>
      </div>
    );
  };

  const renderSinglePallet = (pallet: any) => {
    const isPalletActive = pallet.status !== "INACTIVE";
    const isArchived = isDisabled || !isPalletActive;
    const isOccupied = isPalletActive && (pallet.currentInventoryCount || 0) > 0;

    const bgClass = isArchived
      ? "bg-zinc-100/70 border-zinc-200 text-zinc-400 opacity-60 cursor-not-allowed"
      : isOccupied
        ? "bg-green-50 border-green-300 text-green-800 cursor-pointer hover:bg-green-100/60 hover:shadow-md hover:scale-[1.02]"
        : "bg-amber-50 border-amber-300 text-amber-900 cursor-pointer hover:bg-amber-100/60 hover:shadow-md hover:scale-[1.02]";

    const textClass = isArchived
      ? "text-zinc-400"
      : isOccupied
        ? "text-green-800"
        : "text-amber-900";

    const subtextClass = isArchived
      ? "text-zinc-400"
      : isOccupied
        ? "text-green-600/90 font-medium"
        : "text-amber-600/90 font-medium";

    const iconClass = isArchived
      ? "text-zinc-400"
      : isOccupied
        ? "text-green-700/80"
        : "text-amber-600";

    const progressBgClass = isArchived
      ? "bg-zinc-300"
      : isOccupied
        ? "bg-green-600"
        : "bg-amber-400";

    const progressWidth = isOccupied ? "90%" : "0%";

    return (
      <div key={pallet.id} className="relative group/pallet w-full">
        <div
          onClick={(e) => {
            e.stopPropagation();
            if (!isDisabled) {
              onItemClick?.(pallet, "pallet");
            }
          }}
          className={`p-2 border rounded-xl transition-all ${bgClass}`}
        >
          <div className="flex justify-between items-start">
            <div className="text-left truncate flex-1 min-w-0">
              <div className={`text-xs font-bold leading-tight truncate ${textClass}`} title={pallet.name}>
                {pallet.name}
              </div>
              <div className={`text-[9px] mt-0.5 ${subtextClass} truncate`}>
                {isArchived ? "Archived" : "Pallet"}
              </div>
            </div>
            <IconBox className={`${iconClass} mt-0.5 shrink-0 ml-1`} size={14} stroke={1.5} />
          </div>
          <div className="w-full h-1 bg-slate-200/70 rounded-full overflow-hidden mt-1.5">
            <div 
              className={`h-full rounded-full ${progressBgClass}`} 
              style={{ width: progressWidth }} 
            />
          </div>
        </div>
      </div>
    );
  };

  const renderSingleShipment = () => {
    return (
      <div
        onClick={(e) => {
          e.stopPropagation();
          if (!isDisabled) {
            onItemClick?.(rackLevel, "shipment");
          }
        }}
        className="rounded-xl border border-dashed border-blue-200 p-2 text-center bg-blue-50/50 hover:bg-blue-50 hover:border-blue-400 hover:shadow-md hover:scale-[1.02] transition-all duration-200 cursor-pointer w-full flex flex-col justify-center min-h-[52px]"
      >
        <div className="flex items-center justify-center gap-1.5 text-blue-700">
          <IconBox size={14} stroke={1.5} className="shrink-0" />
          <span className="text-xs font-bold truncate">
            {rackLevel.currentInventoryCount} Items
          </span>
        </div>
        <div className="text-[9px] text-blue-500/80 font-medium mt-0.5 truncate">
          Shipment
        </div>
      </div>
    );
  };

  return (
    <>
      <div className={`${!isActive ? "opacity-60 grayscale-[0.3]" : ""} w-full`}>
        <div
          onClick={(e) => {
            e.stopPropagation();
            onClick?.();
          }}
          onDoubleClick={(e) => {
            e.stopPropagation();
            onDoubleClick?.();
          }}
          className={`border py-3 px-1.5 space-y-3 rounded-2xl shadow-sm transition-all hover:border-slate-300 group cursor-pointer ${
            isSelected
              ? "border-[#FBD037] bg-yellow-50 shadow-md"
              : isActive
                ? "bg-white border-slate-200"
                : "bg-slate-100 border-slate-300"
          }`}
        >
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-2">
              <h5 className="font-bold text-xs text-slate-800">
                {rackLevelName}
              </h5>
              {!isActive && (
                <span className="px-2 py-0.5 rounded text-[9px] font-bold uppercase bg-gray-200 text-gray-600">
                  Inactive
                </span>
              )}
            </div>
          </div>

          {/* Bins / Pallets / Empty Level / Direct Shipments indicator */}
          {items.length === 0 ? (
            <div className="rounded-xl border border-dashed border-slate-200 py-3 text-center text-xs text-slate-400 bg-slate-50/50">
              Empty level
            </div>
          ) : (
            <div className="flex items-center gap-1.5 w-full">
              {/* Left Arrow */}
              {startIndex > 0 && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setStartIndex((prev) => Math.max(0, prev - 2));
                  }}
                  className="flex items-center justify-center w-5 h-10 rounded border border-slate-200 bg-slate-50 hover:bg-slate-100 text-slate-500 hover:text-slate-700 transition shrink-0"
                  title="Previous"
                >
                  <IconChevronLeft size={12} stroke={2.5} />
                </button>
              )}

              {/* Grid for Items */}
              <div className="grid grid-cols-2 gap-2 flex-1 items-stretch">
                {items.slice(startIndex, startIndex + 2).map((item, idx) => {
                  if (item.type === "bin") {
                    return renderSingleBin(item.data);
                  } else if (item.type === "pallet") {
                    return renderSinglePallet(item.data);
                  } else {
                    return renderSingleShipment();
                  }
                })}
              </div>

              {/* Right Arrow */}
              {startIndex + 2 < items.length && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setStartIndex((prev) => prev + 2);
                  }}
                  className="flex items-center justify-center w-5 h-10 rounded border border-slate-200 bg-slate-50 hover:bg-slate-100 text-slate-500 hover:text-slate-700 transition shrink-0"
                  title="Next"
                >
                  <IconChevronRight size={12} stroke={2.5} />
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default RackLevelElement;